export enum ChargeClassEnum {
    FUEL = 'fuel',
    TAX = 'tax',
    INSURANCE = 'insurance',
    SURCHARGE = 'surcharge',
    DUTY = 'duty',
    ADMIN = 'admin',
    OPTION = 'option',
    PICKUP = 'pickup'
}
